import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleProgram } from "../../../../redux/actions/immobilierActions";
import ProgramHero from "./components/ProgramHero";
import Disponibilite from "./components/Disponibilite";
import LotsDetails from "./components/LotsDetails";
import Documents from "./components/Documents";
import Quartier from "./components/Quartier";
import ResponsableProgramme from "./components/ResponsableProgramme";
import ProgrammeHeader from "./components/ProgrammeHeader";
import "./programmes.css";
import toast from "react-hot-toast";
import moment from "moment";
import EditProgramModal from "../../componnents/EditProgramModal";
import { openModal } from "../../../../redux/actions/modalActions";
import mainAxios from "../../../../redux/api/mainAxios";

const Programmes = ({ displayedLot, setDisplayedLot }) => {
  const dispatch = useDispatch();
  const [synchLoading, setSynchLoading] = useState(false);
  const { singleProgram, singleProgramLoading } = useSelector(
    (state) => state.immobilierReducer,
  );
  const { user } = useSelector((state) => state.userAuthReducer);
  const [lastSync, setLastSync] = useState("");
  const componentRef = useRef(null);

  useEffect(() => {
    if (singleProgram?.lastSync) {
      setLastSync(singleProgram.lastSync);
    }
    if (singleProgram?.lots?.[0]) {
      setDisplayedLot(singleProgram.lots[0]);
    }
  }, [singleProgram?.lastSync, singleProgram?.lots]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const updateProgram = async (id, documentId) => {
    setSynchLoading(true);
    try {
      const response = await mainAxios.get(
        `api/update-gridky-single-programme/${id}`,
      );
      if (response.status === 200) {
        toast.success("Synchronisation réussie");
        dispatch(fetchSingleProgram(documentId));
      }
    } catch (error) {
      if (error.response?.status === 404) {
        toast.error("Programme n'est plus disponible sur Gridky");
      } else {
        toast.error("Erreur lors de la synchronisation");
      }
      console.error(error);
    } finally {
      setSynchLoading(false);
    }
  };

  const handleEditProgram = () => {
    dispatch(
      openModal({
        title: `Modifier le Programme ${singleProgram.name}`,
        content: <EditProgramModal programme={singleProgram} />,
      }),
    );
  };

  if (singleProgramLoading || !singleProgram) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-light-grey" ref={componentRef}>
      <ProgrammeHeader
        urlPromoteur={singleProgram?.promoteur?.url}
        promoteurAccesses={singleProgram?.promoteur?.promoteur_accesses}
        userSecteurs={user?.secteurs}
      />
      <div className="d-flex justify-content-between align-items-center mt-20">
        <span className="fs16 regular">
          <span>Dernière synchronisation: </span>
          {moment().diff(lastSync, "minutes") < 1
            ? "À l'instant"
            : moment(lastSync).format("DD/MM/YYYY HH:mm")}
        </span>
        <div className="d-flex gap10">
          <button
            className={"radius5 px-20 py-10 bg-pink text-white border-0"}
            onClick={handleEditProgram}
          >
            Modifier
          </button>
          <button
            className={
              !synchLoading
                ? "radius5 px-20 py-10 bg-pink text-white border-0"
                : "radius5 px-20 py-10 bg-soft-grey text-white border-0 pointer-none"
            }
            onClick={() =>
              updateProgram(
                singleProgram?.original_id,
                singleProgram?.documentId,
              )
            }
            disabled={synchLoading}
          >
            Synchroniser
          </button>
        </div>
      </div>
      {singleProgram && (
        <>
          <ProgramHero program={singleProgram} images={singleProgram.lots} />
          <Disponibilite
            lots={singleProgram.lots}
            setDisplayedLot={setDisplayedLot}
            displayedLot={displayedLot}
            openNewtab={false}
          />
          {displayedLot && <LotsDetails singleLot={displayedLot} />}
          <Documents programDocuments={singleProgram.documents_pdfs} />
          <Quartier
            location={[singleProgram]}
            position={{
              lng: singleProgram.longitude,
              lat: singleProgram.latitude,
            }}
          />
          <ResponsableProgramme
            program={singleProgram.promoteur?.promoteur_accesses}
          />
        </>
      )}
    </div>
  );
};

export default Programmes;
